import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

export const useProducts = () =>
  useQuery({ queryKey: ["products"], queryFn: async () => (await api.get("/products")).data });

export const useCustomers = () =>
  useQuery({ queryKey: ["customers"], queryFn: async () => (await api.get("/customers")).data });

export const NONE_VALUE = "__none__";

export const productOptions = (products, includeNone = true) => [
  ...(includeNone ? [{ value: NONE_VALUE, label: "— None —" }] : []),
  ...(products || []).map((p) => ({ value: p.id, label: p.name })),
];

export const customerOptions = (customers, includeNone = true) => [
  ...(includeNone ? [{ value: NONE_VALUE, label: "— None —" }] : []),
  ...(customers || []).map((c) => ({ value: c.id, label: c.legal_name })),
];

export const nameOf = (list, id) => (list || []).find((x) => x.id === id)?.legal_name
  || (list || []).find((x) => x.id === id)?.name || "—";

export const REVENUE_CATEGORIES = [
  "saas_subscription", "vessel_licence", "user_licence", "setup", "implementation",
  "training", "support", "development", "consulting", "integration", "custom_services", "other",
].map((v) => ({ value: v, label: v.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()) }));

export const EXPENSE_CATEGORIES = [
  "hosting", "compute", "database", "storage", "bandwidth", "backups", "monitoring", "cdn", "dns",
  "cloudflare", "ai", "apis", "github", "testing", "contractors", "asic", "domains", "accounting",
  "insurance", "legal", "banking", "payment_processing", "marketing", "travel", "training", "office",
  "software", "support", "onboarding", "migration", "customer_hosting", "customer_domains",
  "custom_development", "gps", "other",
].map((v) => ({ value: v, label: v.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()) }));

export const BILLING_CYCLES = ["monthly", "quarterly", "annual", "weekly", "fortnightly", "one_off"]
  .map((v) => ({ value: v, label: v.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()) }));

export const opt = (arr) => arr.map((v) => ({ value: v, label: v.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()) }));
